import { dot } from '../utils/do-dot'
import { isInViewport, debounce } from '../utils/micro-utils'
import config from './config'
import { getSrc } from './util'

export default function watch() {
  collectExpImg()
  document.addEventListener('scroll', debounce(collectExpImg))
}

function collectExpImg() {
  const { selector } = config

  const $imgNodeList = document.querySelectorAll(selector)
  const $imgs = Array.prototype.slice.call($imgNodeList)

  const $visibleImgs = $imgs.filter($img => isInViewport($img))
  doExpDot($visibleImgs)
}

/**
 * 将所有图片的相关数据搜集后上报
 * @param {Array<HTMLElement>} $imgs
 */
function doExpDot($imgs) {
  const unExpUrls = {} // pid:imgurl[]

  $imgs.forEach($img => {
    const imgUrl = getSrc($img)
    const isSaveSuccess = saveImgUrl(imgUrl)
    if (isSaveSuccess) {
      const pid = $img.getAttribute(config.pidAttr)

      if (!unExpUrls[pid]) {
        unExpUrls[pid] = []
      }

      unExpUrls[pid].push(imgUrl)
    }
  })

  const allPids = Object.keys(unExpUrls)
  if (allPids.length === 0) return

  const unExpUrls2Exp = {}
  allPids.forEach(pid => {
    unExpUrls2Exp[pid] = unExpUrls[pid].join(',')
  })

  dot(config.logkey, 'EXP', unExpUrls2Exp)
}

const collectedImgs = []
const IMGS_LIMIT = 500
/**
 * @param {String} url
 * @param {Boolean} 是否保存成功
 */
function saveImgUrl(url) {
  // 如果有重复
  if (collectedImgs.indexOf(url) > -1) return false

  if (collectedImgs.length === IMGS_LIMIT) {
    collectedImgs.shift()
  }

  collectedImgs.push(url)

  return true
}
